// src/components/planner/constants/studyTypes.ts
// Fonte única da verdade para todos os tipos de estudo

export interface StudyType {
    value: string;
    label: string;
    color: string;
}

export const STUDY_TYPES: StudyType[] = [
    { value: 'flashcards', label: 'Flashcards', color: '#2563eb' },
    { value: 'questions', label: 'Questões', color: '#9333ea' },
    { value: 'reading', label: 'Leitura', color: '#ea580c' },
    { value: 'review', label: 'Revisão', color: '#10b956' },
    { value: 'mindmap', label: 'Mapa Mental', color: '#0891b2' },
    { value: 'notes', label: 'Resumos e Anotações', color: '#ca8a04' },
    { value: 'class', label: 'Aula', color: '#e11d48' },
    { value: 'other', label: 'Outro', color: '#6B7280' },
];

export const getTypeByValue = (value: string): StudyType =>
    STUDY_TYPES.find(t => t.value === value) ?? STUDY_TYPES[STUDY_TYPES.length - 1];

export const getTypeColor = (session: {
    type: string;
    color?: string;
    customType?: string;
}): string => {
    if (session.type !== 'other') return getTypeByValue(session.type).color;
    return session.color ?? '#6B7280';
};

export const getTypeLabel = (session: {
    type: string;
    subject?: string;
    customType?: string;
}): string => {
    if (session.type !== 'other') return session.subject || getTypeByValue(session.type).label;
    return session.customType || 'Outro';
};